import React from "react";
import PropTypes from "prop-types";
import "./radioButton.css"; // Optional, for custom styles

const RadioButton = ({
  label,
  checked = false,
  disabled = false,
  handleCheck,
  id,
  name,
}) => {
  return (
    <div className="radio-button-container">
      <input
        type="radio"
        className="styled-radio-button"
        value={label}
        checked={checked}
        disabled={disabled}
        onChange={handleCheck}
        id={id}
        name={name}
      />
      <label
        htmlFor={id}
        className={`radio-label ${disabled ? "disabled" : ""}`}
      >
        {label}
      </label>
    </div>
  );
};

RadioButton.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired, // Ensures grouping works properly
};

export default RadioButton;
